const calculationErrorMessage =
  'Calculation unsuccessful. Low and high text pages, source and target translation language fields are required.';

export default calculationErrorMessage;
